import React from 'react';
import { Button } from '@skin-seoul/design-system';

type ButtonProps = React.ComponentProps<typeof Button>;

export const SelectButton = React.forwardRef<
  HTMLButtonElement,
  {
    children: React.ReactNode;
    onClick: () => void;
  } & Omit<ButtonProps, 'children' | 'onClick'>
>(({ children, onClick, ...props }, ref) => (
  <Button
    variant="outline"
    className="w-full h-[36px] bg-generic-0 text-neutral-700 rounded-[8px] border-neutral-100 border text-paragraph-small cursor-pointer inline-flex items-center justify-between whitespace-nowrap hover:bg-neutral-50 [&_span]:text-[14px] [&_span]:text-neutral-700 [&_span]:shrink-0"
    ref={ref}
    onClick={onClick}
    {...props}
  >
    {children}
  </Button>
));

SelectButton.displayName = 'SelectButton';

export const MultipleOptionList = React.forwardRef<
  HTMLDivElement,
  {
    children: React.ReactNode;
  } & React.HTMLAttributes<HTMLDivElement>
>(({ children, ...props }, ref) => (
  <div ref={ref} className="flex flex-col w-full min-w-[240px] gap-4 tablet:gap-0" {...props}>
    {children}
  </div>
));

MultipleOptionList.displayName = 'MultipleOptionList';

export const MultipleOptionCheckbox = ({
  checked,
  children,
  ...props
}: {
  checked: boolean;
  children?: React.ReactNode;
} & React.HTMLAttributes<HTMLSpanElement>) => (
  <span
    className={`inline-flex items-center justify-center w-6 h-6 min-w-6 min-h-6 rounded-[8px] shrink-0 transition-all duration-150 box-border ${checked ? 'bg-primary-400 border-none' : 'border-2 border-neutral-100 bg-generic-0'}`}
    style={{
      ...(checked ? {} : {}),
    }}
    {...props}
  >
    {children}
  </span>
);

export const MultipleOptionLabel = ({
  children,
  ...props
}: {
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLSpanElement>) => (
  <span
    className="flex-1 text-[14px] text-[#737373] text-left font-normal capitalize"
    {...props}
  >
    {children}
  </span>
);

export const MultipleOptionItem = ({
  children,
  isSelected: _isSelected,
  onClick,
  ...props
}: {
  children: React.ReactNode;
  isSelected: boolean;
  onClick: (e: React.MouseEvent) => void;
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'onClick'>) => (
  <div
    className="flex items-center justify-between w-full text-left cursor-pointer text-[15px] text-[#2e2e2e] transition-colors duration-150 box-border hover:bg-[#f5f5f7]"
    onClick={onClick}
    {...props}
  >
    {children}
  </div>
);
